import type { TimerAction } from 'state/timer';

const setTimerEnabled = (enabled: boolean): TimerAction => ({
  type: 'SET_TIMER_ENABLED',
  payload: enabled,
});

const toggleTimerEnabled = (): TimerAction => ({
  type: 'TOGGLE_TIMER_ENABLED',
});

const setTimerWorkRoundsCompleted = (timerId: string): TimerAction => ({
  type: 'SET_TIMER_WORK_ROUNDS_COMPLETED',
  payload: { timerId },
});

const resetTimerCompletions = (): TimerAction => ({
  type: 'RESET_TIMER_COMPLETIONS',
});

export default {
  setTimerEnabled,
  toggleTimerEnabled,
  setTimerWorkRoundsCompleted,
  resetTimerCompletions,
};
